import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Http } from '@angular/http';
import { SaleOffer, InfoCommercializationAssociation } from '../_models/commercialization';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class SaleOfferService extends ApiService {
  constructor(private http: Http) {
    super('api/sale-offer/', http);
  }

  getSaleOffer(id: number): Observable<SaleOffer> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}${id}/`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
  getStatus(): Observable<any> {
    return this.http
      .options(`${this.apiUrl + this.endpointUrl}`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
  create(saleOffer: SaleOffer): Observable<SaleOffer> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, JSON.stringify(saleOffer), { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(saleOffer: SaleOffer): Observable<SaleOffer> {
    const url = `${this.apiUrl + this.endpointUrl}${saleOffer.id}/`;

    // Resolucion prolema al editar barco
    const saleOfferData = { ...saleOffer };

    return this.http.put(url, JSON.stringify(saleOfferData), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }
}

@Injectable()
export class InfoCommercializationAssociationService extends ApiService {
  constructor(private http: Http) {
    super('api/info-commercialization-association/', http);
  }
  get(): Observable<InfoCommercializationAssociation> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}`, {
        headers: this.getHeaders(),
      })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(info: InfoCommercializationAssociation): Observable<InfoCommercializationAssociation> {
    return this.http
      .put(`${this.apiUrl + this.endpointUrl}/`, JSON.stringify(info), { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/commercialization.service.ts